export default {
  id: 'healthHistory/ALLERGIES/v1',
  formSchema: {
    title: 'encounter:widget.healthHistory.allergies',
    type: 'object',
    required: ['id001'],
    properties: {
      id001: {
        type: 'string',
        title: 'encounter:widget.healthHistory.allergies',
        minLength: 1
      }
    }
  },
  uiSchema: {
    id001: { 'ui:widget': 'customCKEditorWidget' },
    'x-customClass': 'problem-description-widget'
  }
};
